import { useEffect, useRef, useState } from "react"
import { promoURL2, apiKeyURL } from "../../../App"
import { useGlobalContext } from "../../data/GlobalContext"

const EasterEggBunny = () => {
  const { username } = useGlobalContext()
  const [eggCount, setEggCount] = useState(0)
  const [specialEggCount, setSpecialEggCount] = useState(0)
  const [bombCount, setBombCount] = useState(0)
  const [timeLeft, setTimeLeft] = useState(30)
  const [isGameRunning, setIsGameRunning] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [showLogout, setShowLogout] = useState(true)
  const [showLogo, setShowLogo] = useState(true)
  const [showInfo, setShowInfo] = useState(false)
  const bunnyRef = useRef(null)
  const gameContainerRef = useRef(null)
  const contentRef = useRef(null)
  const [bunnyPosX, setBunnyPosX] = useState(0)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [multiplier, setMultiplier] = useState(1)
  const [message, setMessage] = useState("")
  const [countdown, setCountdown] = useState(0)
  const [tutorial, setTutorial] = useState(false)
  const orangeEggSpawnedRef = useRef(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const plainUsername = localStorage.getItem("username")
  const [hasChances, setHasChances] = useState(null)
  const { setShowEasterEgg } = useGlobalContext()

  const slides = [
    "/images/easter-egg/how-to-play-container.webp",
    "/images/easter-egg/how-to-play-container-1.webp",
  ]
  const audioRef = useRef(null)

  const [muted, setMuted] = useState(() => {
    const savedMuted = localStorage.getItem("muted")
    return savedMuted !== null ? JSON.parse(savedMuted) : false
  })

  useEffect(() => {
    if (!isLoggedIn) return
    const fetchData = async () => {
      try {
        const response = await fetch(promoURL2, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            cmd: "getFGHEasterEggChances",
            u: username,
          }),
        })

        if (!response.ok) {
          throw new Error("Network response was not ok.")
        }

        const data = await response.json()
        console.log(data)

        if (data.usedChances < data.chances) {
          setHasChances(true)
        } else {
          setHasChances(false)
          console.log("No available chances to start the game.")
        }
      } catch (error) {
        console.log(
          "There was a problem with the login operation. Please try again."
        )
      }
    }

    fetchData()
  }, [isLoggedIn])

  useEffect(() => {
    if (!isLoggedIn) return
    const fetchData = async () => {
      try {
        const response = await fetch(promoURL2, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            cmd: "getFGHEasterEggMultiplier",
            u: username,
          }),
        })

        if (!response.ok) {
          throw new Error("Network response was not ok.")
        }

        const data = await response.json()
        const fetchedMultiplier = Number(data.multiplier)
        setMessage(fetchedMultiplier)
        setMultiplier(fetchedMultiplier)
      } catch (error) {
        console.log(
          "There was a problem with the login operation. Please try again."
        )
      }
    }

    fetchData()
  }, [isLoggedIn])

  const goFullScreen = () => {
    const elem = gameContainerRef.current
    if (!elem) {
      console.error("Element is not available for fullscreen")
      return
    }
    if (elem.requestFullscreen) {
      elem.requestFullscreen()
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen()
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen()
    }
  }

  const handleReload = () => {
    window.location.reload()
  }

  const toggleMute = () => {
    setMuted((prevMuted) => {
      const newMuted = !prevMuted
      localStorage.setItem("muted", JSON.stringify(newMuted))
      return newMuted
    })
  }

  useEffect(() => {
    if (audioRef.current) {
      const storedTime = localStorage.getItem("audioCurrentTime")
      if (storedTime) {
        audioRef.current.currentTime = Number(storedTime)
      }
      audioRef.current.volume = 0.01
    }
  }, [])

  // const showInfoVideo = () => {
  //   setShowInfo(true)
  //   setIsGameRunning(false)
  // }
  const closeInfoVid = () => {
    setShowInfo(false)
  }

  const startGame = () => {
    goFullScreen()
    setShowInfo(false)
    setShowPopup(false)
    setShowLogout(false)
    setShowLogo(false)

    // Show the tutorial when game starts
    setTutorial(true)

    // Wait for 6 seconds before starting the countdown
    setTimeout(() => {
      // Hide the tutorial
      setTutorial(false)
      // Set countdown starting value (e.g., 3 seconds)
      setCountdown(3)
      orangeEggSpawnedRef.current = false

      // Initialize the countdown timer
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval)
            // After the countdown, start the game
            setIsGameRunning(true)
            setTimeLeft(30)
            setEggCount(0)
            setBombCount(0)
            setSpecialEggCount(0)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    }, 3000) // 6000ms equals 6 seconds for the tutorial display
  }

  useEffect(() => {
    if (isGameRunning) {
      const timerInterval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval)
            setIsGameRunning(false)
            setShowPopup(true)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      const isMobile = window.matchMedia("(pointer: coarse)").matches
      const spawnDelay = isMobile ? 1500 : 1000
      const spawnInterval = setInterval(spawnObjects, spawnDelay)

      return () => {
        clearInterval(timerInterval)
        clearInterval(spawnInterval)
      }
    }
  }, [isGameRunning])

  const moveBunny = (direction) => {
    const maxWidth =
      gameContainerRef.current.offsetWidth - bunnyRef.current.offsetWidth
    setBunnyPosX((prev) => {
      const newPos =
        direction === "left"
          ? Math.max(prev - 50, 0)
          : Math.min(prev + 50, maxWidth)
      return newPos
    })
  }

  useEffect(() => {
    const handleKey = (e) => {
      if (!isGameRunning) return
      if (e.key === "ArrowLeft") moveBunny("left")
      if (e.key === "ArrowRight") moveBunny("right")
    }
    window.addEventListener("keydown", handleKey)
    return () => window.removeEventListener("keydown", handleKey)
  }, [isGameRunning])

  const spawnObjects = () => {
    if (!orangeEggSpawnedRef.current && Math.random() < 0.5) {
      for (let i = 0; i < 3; i++) {
        setTimeout(() => {
          createFallingObject(
            "egg",
            "/images/easter-egg/golden-egg.webp",
            multiplier
          )
        }, i * 5500)
      }
      orangeEggSpawnedRef.current = true
    }
    createFallingObject("egg-pink", "/images/easter-egg/pink-egg.webp")
    createFallingObject("bomb", "/images/easter-egg/bomb.webp")
  }

  const createFallingObject = (type, imgSrc, multiplierValue = null) => {
    const content = contentRef.current
    const obj = document.createElement("div")
    obj.className = `falling-object ${type}`
    obj.style.left = Math.random() * (content.offsetWidth - 50) + "px"

    // Set the multiplier as a data attribute if provided (orange egg only)
    if (multiplierValue && type === "egg") {
      obj.dataset.multiplier = multiplierValue
    }

    obj.innerHTML = `<img src="${imgSrc}" />`
    content.appendChild(obj)

    const fallSpeed = 4 + Math.random() * 3

    const animate = () => {
      if (!isGameRunning) return obj.remove()
      const currentTop = parseFloat(obj.style.top || "-100px")
      obj.style.top = currentTop + fallSpeed + "px"

      // Check if the object has reached the bottom of the window
      if (currentTop > window.innerHeight - 80) {
        if (type === "egg-pink") {
          obj.innerHTML = `<img src="/images/easter-egg/pink-egg-cracked.webp" />`

          setTimeout(() => {
            obj.remove()
          }, 1000)
          return
        }
        if (type === "bomb") {
          obj.innerHTML = `<img src="/images/easter-egg/bomb-boom.webp" />`

          setTimeout(() => {
            obj.remove()
          }, 1000)
          return
        }
        if (type === "egg") {
          obj.innerHTML = `<img src="/images/easter-egg/golden-egg-cracked.webp" />`
          setTimeout(() => {
            obj.remove()
          }, 1000)
          return
        }
        // For other objects (or if you don't want to change the image), just remove it
        return obj.remove()
      }

      checkCollision(obj, type)
      requestAnimationFrame(animate)
    }

    animate()
  }

  const checkCollision = (obj, type) => {
    if (!bunnyRef.current) return
    const bunny = bunnyRef.current.getBoundingClientRect()
    const item = obj.getBoundingClientRect()

    if (
      item.bottom >= bunny.top &&
      item.top <= bunny.bottom &&
      item.right >= bunny.left &&
      item.left <= bunny.right
    ) {
      obj.remove()
      if (type.includes("egg")) {
        setEggCount((prev) => prev + 1)
        // If it's an orange egg (type 'egg' with a multiplier), track it separately
        if (type === "egg" && obj.dataset.multiplier) {
          setSpecialEggCount((prev) => prev + 1)
        }
      }
      if (type === "bomb") {
        setBombCount((prev) => prev + 1)
      }
    }
  }

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("isLoggedIn") === "true"

    if (loggedInStatus) {
      setIsLoggedIn(true)
    }
  }, [])

  useEffect(() => {
    if (isLoggedIn) {
      document.body.classList.add("isLoggedIn")
    } else {
      document.body.classList.remove("isLoggedIn")
    }
  }, [isLoggedIn])

  useEffect(() => {
    const isDesktop = window.matchMedia("(pointer: fine)").matches

    if (!isDesktop) return

    const handleMouseMove = (e) => {
      if (!isGameRunning || !bunnyRef.current || !gameContainerRef.current)
        return

      const containerRect = gameContainerRef.current.getBoundingClientRect()
      const bunnyWidth = bunnyRef.current.offsetWidth

      let mouseX = e.clientX - containerRect.left - bunnyWidth / 2
      mouseX = Math.max(0, Math.min(mouseX, containerRect.width - bunnyWidth))

      bunnyRef.current.style.left = `${mouseX}px`
    }

    const container = gameContainerRef.current
    if (container) {
      container.addEventListener("mousemove", handleMouseMove)
    }

    return () => {
      if (container) {
        container.removeEventListener("mousemove", handleMouseMove)
      }
    }
  }, [isGameRunning])

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length)
    }, 5000)

    return () => clearInterval(timer)
  }, [slides.length])

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (audioRef.current) {
        localStorage.setItem("audioCurrentTime", audioRef.current.currentTime)
      }
    }
    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => window.removeEventListener("beforeunload", handleBeforeUnload)
  }, [])

  function uint8ArrayToBase64(uint8Array) {
    const binary = Array.from(uint8Array, (byte) =>
      String.fromCharCode(byte)
    ).join("")
    return window.btoa(binary)
  }

  async function encrypt(text) {
    const encoder = new TextEncoder()
    const keyData = encoder.encode(apiKeyURL.padEnd(16, "0").slice(0, 16))
    const ivData = encoder.encode(apiKeyURL.padEnd(16, "0").slice(0, 16))

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-CBC", length: 128 },
      false,
      ["encrypt"]
    )

    const encodedText = encoder.encode(text)

    const encrypted = await window.crypto.subtle.encrypt(
      { name: "AES-CBC", iv: ivData },
      cryptoKey,
      encodedText
    )

    return new Uint8Array(encrypted)
  }

  useEffect(() => {
    if (!showPopup) return

    const redeemScore = async () => {
      // Calculate the final score
      const finalScore =
        Math.max(eggCount - bombCount, 0) + specialEggCount * multiplier

      try {
        // Encrypt the score
        const encryptedScore = await encrypt(finalScore.toString())
        const encryptedAmount = uint8ArrayToBase64(encryptedScore)
        // Encrypt the egg count
        const encryptedEggValue = await encrypt(eggCount.toString())
        const encryptedEggs = uint8ArrayToBase64(encryptedEggValue)

        // Encrypt the bomb count
        const encryptedBombValue = await encrypt(bombCount.toString())
        const encryptedBombs = uint8ArrayToBase64(encryptedBombValue)

        // remove your manual headers block…
        const response = await fetch(promoURL2, {
          method: "POST",
          body: new URLSearchParams({
            cmd: "redeemFGHEasterEgg",
            u: username,
            a: encryptedAmount,
            eggs: encryptedEggs,
            bombs: encryptedBombs,
          }),
        })

        if (!response.ok) {
          throw new Error("Network response was not ok.")
        }

        const data = await response.json()
        console.log("Redeem response:", data.s)
      } catch (error) {
        console.error("Error redeeming score:", error)
      }
    }

    redeemScore()
  }, [showPopup])

  return (
    <>
      <audio ref={audioRef} autoPlay loop muted={muted} hidden>
        <source
          src="/images/easter-egg/sound/start-game-music.mp3"
          type="audio/mp3"
        />
        Your browser does not support the audio element.
      </audio>

      {isLoggedIn ? (
        <>
          {/* <div className="bg-blur"></div> */}

          <div className="game-content">
            <div className="game-container" ref={gameContainerRef}>
              {!isGameRunning && !showPopup && (
                <div className="start-screen">
                  {!tutorial && (
                    <img
                      className="illustration"
                      src="/images/easter-egg/illustration.webp"
                      alt=""
                    />
                  )}
                  {tutorial && (
                    <>
                      <div className="tutorial-container">
                        <div className="tutorial-content">
                          <p className="tutorial-title">Wait...</p>
                          <p>
                            Move the bunny using arrow keys or mouse to collect
                            the eggs. Avoid bombs!
                          </p>
                          <div className="tutorial-content--arrow">
                            <div>
                              <img
                                className="arrow-left"
                                src="/images/easter-egg/arrow-left.webp"
                                alt="arrow-left"
                              />
                            </div>
                            <div>
                              <img
                                className="arrow-right"
                                src="/images/easter-egg/arrow-right.webp"
                                alt="arrow-right"
                              />
                            </div>
                          </div>
                          <div className="bunny-wrapper">
                            <img
                              src="/images/easter-egg/bunny.webp"
                              alt="bunny"
                              className="bunny-animation"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {countdown > 0 ? (
                    <>
                      <div className="start-game-countdown">
                        <h2>Starting the game in {countdown}secs</h2>
                        <p>please, do not refresh the page</p>
                      </div>
                    </>
                  ) : (
                    <>
                      {hasChances ? null : (
                        <div className="desc-chances">
                          <p>No available chances to start the game.</p>
                        </div>
                      )}

                      {!tutorial && (
                        <div className="game-btns">
                          <div className="game-btns-container">
                            {hasChances ? (
                              <img
                                className="btn"
                                onClick={startGame}
                                src="/images/easter-egg/start-btn.png"
                                alt="Start Game"
                              />
                            ) : (
                              <img
                                className="game-disabled"
                                src="/images/easter-egg/start-btn.png"
                                alt="Start Game"
                              />
                            )}
                            <img
                              onClick={toggleMute}
                              className="sound-btn"
                              src={
                                muted
                                  ? "/images/easter-egg/unmuted.png"
                                  : "/images/easter-egg/muted.png"
                              }
                              alt={muted ? "Unmute" : "Mute"}
                            />
                            {/* <img
                            onClick={showInfoVideo}
                            className="info-btn"
                            src="/images/easter-egg/info.png"
                          /> */}
                          </div>
                          <div className="game-button">
                            <button onClick={() => setShowEasterEgg(false)}>
                              close
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {showPopup && (
                <div className="popup">
                  <div className="popup-bg">
                    <img src="/images/easter-egg/times-up-bg.webp" alt="" />
                  </div>
                  <div className="popup-content">
                    <p>
                      You collected
                      <span className="highlight"> {eggCount}</span>{" "}
                      <img
                        className="pink-egg"
                        src="/images/easter-egg/pink-egg.webp"
                        alt=""
                      />{" "}
                      eggs.
                    </p>
                    {specialEggCount > 0 && (
                      <p>
                        You collected special{" "}
                        <span className="highlight"> {specialEggCount} </span>
                        <img
                          className="golden-egg"
                          src="/images/easter-egg/golden-egg.webp"
                          alt="Golden Egg"
                        />{" "}
                        egg
                      </p>
                    )}
                    <p>
                      You hit <span className="highlight">{bombCount}</span>{" "}
                      <img
                        className="bomb"
                        src="/images/easter-egg/bomb.webp"
                        alt=""
                      />
                      bombs.
                    </p>
                    <p>
                      Your final score is:{" "}
                      <span className="highlight">
                        {Math.max(eggCount - bombCount, 0) +
                          specialEggCount * multiplier}
                      </span>
                    </p>

                    <div className="back-container">
                      <button onClick={handleReload}>
                        <img
                          className="back"
                          src="/images/easter-egg/back-btn.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {showInfo && (
                <>
                  <div className="how-to-play">
                    {slides.map((slide, index) => (
                      <div
                        className="how-to-play-container slide"
                        key={index}
                        style={{
                          display: index === currentIndex ? "block" : "none",
                        }}
                      >
                        <img src={slide} alt={`Slide ${index + 1}`} />
                      </div>
                    ))}
                    <div className="close-btn" onClick={closeInfoVid}>
                      <img src="/images/easter-egg/close.png" />
                    </div>
                  </div>
                </>
              )}

              {isGameRunning && (
                <>
                  <div className="collected-egg">
                    <div className="scoreboard">
                      <span>⏳ {timeLeft}s</span>
                    </div>
                    <div className="fgh-logo">
                      <img src="/images/easter-egg/FGH.png" alt="" />
                    </div>
                    <p className="scoreboard-title">Scoreboard</p>
                    <div className="collected-egg-content">
                      <img src="/images/easter-egg/pink-egg.webp" /> ={" "}
                      <span className="count">{eggCount}</span>
                    </div>{" "}
                    <div className="collected-egg-content">
                      <img
                        src="/images/easter-egg/golden-egg.webp"
                        alt="Golden Egg"
                      />{" "}
                      = <span className="count">{specialEggCount}</span>
                    </div>
                    <div className="collected-egg-content">
                      <img src="/images/easter-egg/bomb.webp" /> ={" "}
                      <span className="count">{bombCount}</span>
                    </div>{" "}
                    <div className="collected-egg-content">
                      <img src="/images/easter-egg/icons8-target.gif" /> =
                      <span className="count">
                        {Math.max(eggCount - bombCount, 0)}
                      </span>
                    </div>{" "}
                    <div className="multiplier-container">
                      <div>
                        <img src="/images/easter-egg/golden-egg.webp" alt="" />
                      </div>
                      <div className="golden-text">
                        {message ? <p>x{message}</p> : <p>Loading...</p>}
                      </div>
                    </div>
                  </div>
                  <div className="game-area" ref={gameContainerRef}>
                    <div className="arrow-container">
                      <div className="arrows">
                        <button
                          id="left"
                          onClick={() => moveBunny("left")}
                        ></button>
                        <button
                          id="right"
                          onClick={() => moveBunny("right")}
                        ></button>
                      </div>
                    </div>

                    <div className="game-content" ref={contentRef}>
                      <img
                        ref={bunnyRef}
                        src="/images/easter-egg/bunny.webp"
                        alt="bunny"
                        className="bunny"
                        style={{ left: bunnyPosX }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  )
}

export default EasterEggBunny
